import http from "../../http";

const index = {

    searchCompanyList(r) {
        return http.get("/gateway/api/sycompany/pc/company/listCompanyOption", r)
    },
    getUserJson(r) {
        return http.get("/gateway/api/sycompany/pc/company/getUserJson", r)
    },
    getCompanyByOrgCode(r) {
        return http.get("/gateway/api/sycompany/pc/company/getCompanyByOrgCode", r)
    },
    getCompanyByPage(r) {
        return http.get("/gateway/api/sycompany/pc/company/getCompanyByPage", r);
    }
}

export default index
